import React from 'react';
import Footer2Component from '../commons/footer2';
import MenuComponent from '../commons/menu';
import axios from 'axios';
import {IndexLink, Link} from 'react-router';

import ReactGA from 'react-ga';
import {isMobile} from 'react-device-detect';

export default class AdvertisePage extends React.Component {
    constructor(props) {
        super(props);

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);

        this.state = {
            hasError: false,
            email: '',
        }
    }

    handleChange = (event) => {
        let hasError = event.target.value !== ''?false:true;
        this.setState({email: event.target.value, hasError: hasError});
    }

    handlePostCoupon = (event) => {
        if (this.state.email === '') {
            this.setState({hasError: true});
            return;
        }
        let data = new FormData();
        data.append('email', this.state.email);
        axios.post('/code/api_generate.php?api=pushCoupoun', data, {
            progress: (progressEvent) => {
            }
        })
            .then(response => {
                window.location = "coupon/contact-us";
            })
            .catch(error => {
                console.log("error: handlePostCoupon")
            });
    }

    render() {
        return (
            <div>
                <div className="advertise_boxs" id={isMobile ? "m_welcome_mobile" : "m_welcome"}>
                    <div className={"block-001"}>
                        <Link to="/business"><img className={"img_logo"} src="/static/img/appimg/h_logo.png"/></Link>
                        {isMobile ?
                            <MenuComponent is_hide={4}/>
                            :
                            <Link className="btn_login" to="/signin">Sign in</Link>
                        }
                    </div>
                    <div className={"block-002"}>
                        <div className={"content"}>
                            <p>&nbsp;</p>
                            <h2>Try Versity ads with $15 on us.</h2>
                            <p>Start advertising on the world's largest university network.</p>
                            <p>&nbsp;</p>
                        </div>
                        {isMobile ? "" :
                            <div className={"content-right"}>
                                <p>&nbsp;</p>
                                <p>Offer valid for new Versity advertisers. Limit one per customer.</p>
                                <div className={"content-login"}>
                                    <h2 className={"t-24"}>Request $15 in Versity ad credits sent directly to your
                                        email.</h2>
                                    <a className={"sign-in"} href={"/signin"}>Sign In with Versity</a>
                                    <input type={"email"} placeholder={"Work Email*"} onChange={this.handleChange.bind(this)}/>
                                    {this.state.hasError?<p className={"cls-error"}>Required</p>:""}
                                    <p className={"mt15"}>
                                        By submitting this form, you agree that we may use the data you provide to
                                        contact
                                        you with information related to your request/submission and the relevant Versity
                                        product. If you are a Versity member, you can control the messages you receive
                                        from
                                        Versity in your settings. If you are a guest, you can unsubscribe from Versity
                                        marketing emails at any time by clicking the unsubscribe link in the email. To
                                        learn
                                        more, see Versity's Privacy Settings.
                                    </p>
                                    <div className={"mrtb-10 text-left"}>
                                        <a className={"request-text"} onClick={this.handlePostCoupon.bind(this)}>Request My $15 Promo</a>
                                        <div className={"bl-right"}>Required fields*</div>
                                    </div>
                                </div>
                                <div className={"clearfix"}></div>
                            </div>
                        }
                    </div>
                    <div className={"block-003"}>
                        {isMobile ?
                            <div className={"content-right"}>
                                <p>Offer valid for new Versity advertisers. Limit one per customer.</p>
                                <div className={"content-login"}>
                                    <h2 className={"t-24"}>Request $15 in Versity ad credits sent directly to your email.</h2>
                                    <a className={"sign-in"} href={"/signin"}>Sign In with Versity</a>
                                    <input type={"email"} placeholder={"Work Email*"} onChange={this.handleChange.bind(this)}/>
                                    {this.state.hasError?<p className={"cls-error"}>Required</p>:""}
                                    <p className={"mt15"}>
                                        By submitting this form, you agree that we may use the data you provide to
                                        contact
                                        you with information related to your request/submission and the relevant Versity
                                        product. If you are a Versity member, you can control the messages you receive
                                        from
                                        Versity in your settings. If you are a guest, you can unsubscribe from Versity
                                        marketing emails at any time by clicking the unsubscribe link in the email. To
                                        learn
                                        more, see Versity's Privacy Settings.
                                    </p>
                                    <div className={"text-right mrb-10"}><span>Required fields*</span></div>
                                    <a className={"request-text"} onClick={this.handlePostCoupon.bind(this)}>Request My $15 Promo</a>
                                </div>
                            </div>
                            :
                            <div className={"content3-0"}>
                                <div className={"content"}>
                                    <p>Reach students from 4,000 colleges and universities. Target by degree, gpa,
                                        majors, skills, work experience and more.</p>
                                    <a href={"/talent/contact-us"}>Learn More</a>
                                </div>
                            </div>
                        }
                        <div className={"content3"}>
                            <h4 className={'t-24'}>Create easy ads that drive traffic to your website</h4>
                        </div>
                        <div className={"content4"}>
                            <div className={"item-001"}>
                                {isMobile ? "" : <img className="icon_cc" src="static/img/appimg/mk_img_02.png"/>}
                                <div className={"right"}>
                                    <b>CREATED CONTENT</b>
                                    <p className={"b-t"}>Create easy and effective job ads in minutes</p>
                                    <p>&nbsp;</p>
                                    <small>Create social job campaigns with a compelling headline, description & image
                                        or video.<br/>
                                        Promote jobs to your target audiences on desktop, mobile & tablet.
                                    </small>
                                </div>
                                {isMobile ? <img className="icon_cc" src="static/img/appimg/mk_img_02.png"/> : ""}
                            </div>
                            <div className={"item-002"}>
                                <div className={"left"}>
                                    <b>PROMOTED JOB</b>
                                    <p className={"b-t"}>Drive quality traffic to your Career site</p>
                                    <p>&nbsp;</p>
                                    <small>Promote content to your target audiences in their personalized feed with jobs
                                        that build engagement, drive awareness & lead generation.
                                    </small>
                                </div>
                                <img className="icon_cc" src="static/img/appimg/mk_img_03.png"/>
                            </div>
                            <div className={"item-003"}>
                                {isMobile ? "" : <img className="icon_cc" src="static/img/appimg/mk_img_04.png"/>}
                                <div className={"right"}>
                                    <b>BUGETED ADS</b>
                                    <p className={"b-t"}>Set your own budget and control costs</p>
                                    <p>&nbsp;</p>
                                    <small>Promote your jobs using your own budget and control costs with PPC pricing,
                                        and analytics that is easy to measure & track. You'll see high-level performance
                                        details including impressions, clicks, and conversions.
                                    </small>
                                </div>
                                {isMobile ? <img className="icon_cc" src="static/img/appimg/mk_img_04.png"/> : ""}
                            </div>
                        </div>
                        <div className={"content5"}>
                            <div className={"item-002"}>
                                <img className="icon_cc" src="/static/img/appimg/mk_img_05.png"/>
                                <p>
                                    Versity is one of our most valuable channels for qualified leads. We can access the<br/>
                                    broadest possible community of students, and target them with precision.
                                    <br/><br/>
                                    Kathleen Anne Golds, Director of Campus Recruitment, ImpeliQ
                                </p>
                            </div>
                            <p>&nbsp;</p>
                        </div>
                        <div className={"block-006"}>
                            <div className={"column"}>
                                <span className={"txt-001"}>Start driving leads and awareness with targeted content<br/>marketing on Versity</span>
                                <span className={"btn-001"}><Link className={"btn request-text-2"} to="/employers/signup">Request My $15 Promo</Link></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"txtCenter"}>
                    <Footer2Component/>
                </div>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/pages/marketing.js
 **/